export class RestoreTreeConstants {
    private static _ENTITY_TO_COMPUTE_VIEW_QUERY_PARAMETERS_MAP: Object = {
        'datacenter': 'entityType=host$folder,host$cluster,host$computeResource&parentType=datacenter&format=tree',
        'folder': 'entityType=folder,cluster,computeResource&parentType=folder&format=tree',
        'cluster': 'entityType=host,Resources$resourcePool&parentType=cluster&format=tree',
        'computeResource': 'entityType=Resources$resourcePool&parentType=computeResource&format=tree',
        'resourcePool': 'entityType=resourcePool&parentType=resourcePool&format=tree'
    };
    public static getComputeViewChildrenQueryParameters(entity: string): string {
       return RestoreTreeConstants._ENTITY_TO_COMPUTE_VIEW_QUERY_PARAMETERS_MAP[entity];
    }

    private static _ENTITY_TO_FOLDER_VIEW_QUERY_PARAMETERS_MAP: Object = {
        'vcenter': 'parentType=vcenter&format=tree',
        'folder': 'entityType=folder,datacenter&parentType=folder&format=tree',
        'datacenter': 'entityType=vm$folder&parentType=datacenter&format=tree'
    };
    public static getFolderViewChildrenQueryParameters(entity: string): string {
       return RestoreTreeConstants._ENTITY_TO_FOLDER_VIEW_QUERY_PARAMETERS_MAP[entity];
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/out-of-place-restore/out-of-place-restore-constants.ts